import type { DomConfig, Model } from '@bryntum/core-thin';
import { getEmployeeInitialsFromName } from '../../../utils/employeeInitials';

interface ResourceRecord {
  name: string;
  avatarUrl: string | null;
}

const avatarChild = (record: ResourceRecord): DomConfig =>
  record.avatarUrl
    ? {
        tag: 'img',
        src: record.avatarUrl,
        alt: record.name,
        class: 'avatar-img rounded-circle',
      }
    : {
        class: 'avatar-title rounded-circle',
        text: getEmployeeInitialsFromName(record.name),
      };

const avatarWrapper = (record: ResourceRecord): DomConfig => ({
  class: 'avatar avatar-xs',
  children: [avatarChild(record)],
});

const nameEl = (name: string): DomConfig => ({
  tag: 'span',
  class: 'text-truncate',
  style: 'min-width:0',
  text: name,
});

export const renderResourceCell = (record: Model): DomConfig => {
  const isOpenShiftRow = record.get('isOpenShiftRow') as boolean | undefined;

  if (isOpenShiftRow) {
    return {
      class: 'd-flex align-items-center overflow-hidden',
      children: [
        {
          tag: 'span',
          class: 'fw-bold text-truncate text-uppercase',
          style: 'min-width:0; font-size:0.75rem',
          text: String(record.get('name') ?? ''),
        },
      ],
    };
  }

  const name = String(record.get('name') ?? '');
  const avatarUrl = record.get('avatarUrl') as string | null;
  const resource: ResourceRecord = { name, avatarUrl };

  return {
    class: 'd-flex align-items-center gap-2 overflow-hidden',
    children: [avatarWrapper(resource), nameEl(name)],
  };
};
